import { render, staticRenderFns } from "./SurveysInstances.vue?vue&type=template&id=1e0d6628"
import script from "./SurveysInstances.vue?vue&type=script&lang=js"
export * from "./SurveysInstances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports